/**
 * RhymeColorLegend - Inline underline-tag legend for rhyme category colors.
 *
 * Replaces the old dot+label layout with compact underlined tags that
 * match the left-border colors used on dense pills.
 */

import React from 'react'

// Color/textColor pairs matching the pill border colors in RhymeGroupCluster
const RHYME_COLORS = [
  { type: 'perfect',     color: '#22c55e', textColor: '#166534', label: 'Perfect' },
  { type: 'family',      color: '#3b82f6', textColor: '#1e40af', label: 'Family' },
  { type: 'additive',    color: '#06b6d4', textColor: '#155e75', label: 'Additive' },
  { type: 'subtractive', color: '#eab308', textColor: '#854d0e', label: 'Subtractive' },
  { type: 'assonance',   color: '#f97316', textColor: '#9a3412', label: 'Assonance' },
  { type: 'consonance',  color: '#a855f7', textColor: '#6b21a8', label: 'Consonance' },
] as const

export const RhymeColorLegend: React.FC = () => {
  return (
    <div
      className="flex flex-wrap gap-x-2 gap-y-0.5"
      data-testid="rhyme-color-legend"
    >
      {RHYME_COLORS.map(({ type, color, textColor, label }) => (
        <span
          key={type}
          className="pb-px text-[9px] font-medium"
          style={{ borderBottom: `2px solid ${color}`, color: textColor }}
          data-testid={`legend-tag-${type}`}
        >
          {label}
        </span>
      ))}
    </div>
  )
}
